import React from 'react';
import type { RichContent } from '../../types';
import { isValidImageUrl } from '../../utils/fileValidation';

interface CardMessageProps {
  content: RichContent;
}

const CardMessage = React.memo(function CardMessage({ content }: CardMessageProps) {
  return (
    <div className="mt-2 border rounded-lg overflow-hidden bg-white">
      {content.image && isValidImageUrl(content.image) && (
        <img
          src={content.image}
          alt={content.title || 'Card image'}
          className="w-full h-32 object-cover"
          loading="lazy"
          decoding="async"
        />
      )}
      <div className="p-3">
        {content.title && <h3 className="font-semibold text-sm mb-1">{content.title}</h3>}
        {content.description && <p className="text-xs text-gray-600">{content.description}</p>}
        {content.actions && content.actions.length > 0 && (
          <div className="flex gap-2 mt-3">
            {content.actions.map((action, idx) => (
              <button
                key={idx}
                onClick={() => action.onClick?.()}
                type="button"
                className="px-3 py-1 text-xs rounded bg-blue-600 text-white hover:bg-blue-700 focus:outline-2 focus:outline-blue-500"
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

export default CardMessage;
